// extracted by mini-css-extract-plugin
module.exports = {"body":"Popouts_body__1tK4D"};